const MAX_CHARS = 6;
const truncateTableString = (str: string | undefined): string => {
  if (!str) return '';
  return str.slice(0, MAX_CHARS).concat('...');
};

export default truncateTableString;
